export default "__VITE_ASSET__B1T0hxBU__"